import { useEffect, useState } from "react";

export const useTimeLeft = (targetTime: number) => {
  const [timeLeft, setTimeLeft] = useState(() => targetTime - Date.now());

  useEffect(() => {
    const updateTimeLeft = () => setTimeLeft(targetTime - Date.now());
    const intervalId = window.setInterval(updateTimeLeft, 30000);

    updateTimeLeft();

    return () => window.clearInterval(intervalId);
  }, [targetTime]);

  return timeLeft;
};
